import type { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { ROUTES } from '@/shared/config/routes';
import { useReelsCreatorAllowed } from '@/shared/config/useReelsCreatorAllowed';

interface ReelsCreatorRouteGuardProps {
  children: ReactNode;
  /** Shown while access is being checked. */
  fallback?: ReactNode;
}

/**
 * `isAllowed` reads false while the ACL check is still in flight, so the loading branch
 * must render the fallback (nothing by default) rather than redirect: collapsing it into the
 * `!isAllowed` redirect bounces an allowed user home before visibility has resolved.
 */
export const ReelsCreatorRouteGuard = ({
  children,
  fallback = null,
}: ReelsCreatorRouteGuardProps) => {
  const { isAllowed, isLoading } = useReelsCreatorAllowed();

  if (isLoading) {
    return <>{fallback}</>;
  }

  if (!isAllowed) {
    return <Navigate to={ROUTES.HOME} replace />;
  }

  return <>{children}</>;
};
